import { connect } from 'react-redux';
import { getVerificationLoadingState } from '../publicSession/selectors';
import { updateEmail } from '../publicSession/actions';
const mapStateToProps = (state)=>getVerificationLoadingState(state);
const mapDispatchToProps = {
    changeEmail: updateEmail
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=VerificationEmailInput.container.js.map